import { SvgIcon } from '@mui/material';

type MoneyOffProps = {
  color: string,
}
export const MoneyOff = ({
  color,
}: MoneyOffProps):JSX.Element  => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={ { color } }
  >
    <path d="M12.5001 6.9C14.2801 6.9 14.9401 7.75 15.0001 9H17.2101C17.1401 7.28 16.0901 5.7 14.0001 5.19V3H11.0001V5.16C10.4701 5.28 9.97006 5.46 9.52006 5.7L10.9901 7.17C11.4001 7 11.9001 6.9 12.5001 6.9ZM5.33006 4.06L4.06006 5.33L7.50006 8.77C7.50006 10.85 9.06006 11.98 11.4101 12.68L14.9201 16.19C14.5801 16.67 13.8701 17.1 12.5001 17.1C10.4401 17.1 9.63006 16.18 9.52006 15H7.32006C7.44006 17.19 9.08006 18.42 11.0001 18.83V21H14.0001V18.85C14.9601 18.67 15.8201 18.3 16.4501 17.73L18.6701 19.95L19.9401 18.68L5.33006 4.06Z" />
  </SvgIcon>
);
